import { PassouFalhouEnum } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/consulta-seguimento/enums-consultaSeguimento'
import { calculateResultadoPergunta07 } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/consulta-seguimento/perguntas/consulta-seguimento-pergunta-07/utils-consultaSeguimentoPergunta07'
import { MchatRfAplicacaoQueryModel } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/model-mChatRf'

import { HistoricoMChatHeaderTableItem } from '../components/HistoricoMchatHeaderTableItem'
import { HistoricoMChatPerguntaSection } from '../components/HistoricoMchatPerguntaSection'
import { HistoricoMChatResultadoParcialTableItem } from '../components/HistoricoMChatResultadoParcialTableItem'
import { HistoricoMchatTwoColumnsEvenlyTableItem } from '../components/HistoricoMchatTwoColumnsEvenlyTableItem'
import { convertAplicacaoPergunta07 } from './converter-HistoricoMchatPergunta07'

interface HistoricoMChatRfPergunta07Props {
  aplicacoes: ReadonlyArray<MchatRfAplicacaoQueryModel>
}

export const HistoricoMChatRfPergunta07 = (props: Readonly<HistoricoMChatRfPergunta07Props>) => {
  const { aplicacoes } = props

  const converted = convertAplicacaoPergunta07(aplicacoes)
  if (converted == null) return null

  const { header, perguntas, apontaComDedo, apontaPor, model } = converted
  if (header === null) return null

  const resultado = calculateResultadoPergunta07(model)

  return (
    <HistoricoMChatPerguntaSection>
      <HistoricoMChatHeaderTableItem
        numeroPergunta='7'
        title={header.textoPergunta}
        value={header.stPassou}
        pergunta='“Seu filho alguma vez já quis que você olhasse para algo interessante como...”'
      />
      <HistoricoMchatTwoColumnsEvenlyTableItem perguntas={perguntas} />
      {apontaComDedo && <HistoricoMchatTwoColumnsEvenlyTableItem perguntas={[apontaComDedo]} />}
      {apontaPor && <HistoricoMchatTwoColumnsEvenlyTableItem perguntas={[apontaPor]} />}
      {resultado && <HistoricoMChatResultadoParcialTableItem valor={resultado === PassouFalhouEnum.PASSOU} />}
    </HistoricoMChatPerguntaSection>
  )
}
